import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MercadoPagoComponent } from './components/mercadopago.component';
import { PromotionBankComponent } from './components/promotion-bank.component';

const COMPONENTS = [
  MercadoPagoComponent,
  PromotionBankComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class MercadopagoModule { }
